<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    title="Signature en cours"
    class="!max-w-[720px]">
    <template v-slot:modalBody>
      <div
        class="flex-col gap-[12px]"
        v-if="props.show_body">
        Le PIF a été signé par
        <span class="font-bold">{{ props.nom_prenom }} </span>
        le
        <span class="font-bold">{{ formatDate(props.date) }}</span
        >. <br /><br />
        Le document a été transmis au participant
        <span
          class="font-bold"
          v-if="props.nom_prenom_participant"
          >{{ props.nom_prenom_participant }}</span
        >
        pour signature. Une fois la signature effectuée, le document finalisé
        sera automatiquement disponible au téléchargement dans votre espace.
      </div>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import { parse } from 'date-fns';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      class?: string;
      show_body: boolean;
      date?: string;
      nom_prenom?: string;
      email?: string;
      signature_maintenance?: boolean;
      nom_prenom_participant?: string;
    }>(),
    {
      class: ''
    }
  );

  const formatDate = (dateString: string | undefined) => {
    if (!dateString) return '';

    const date = parse(dateString, 'dd/MM/yyyy HH:mm:ss', new Date());

    const datePart = date.toLocaleDateString('fr-FR');
    const timePart = date
      .toLocaleTimeString('fr-FR', {
        hour: '2-digit',
        minute: '2-digit'
      })
      .replace(':', 'h');

    return `${datePart} à ${timePart}`;
  };
</script>

<style lang="scss" scoped></style>
